import { EventEmitter } from 'events';

class CoreSearchEvents extends EventEmitter { }
export const searchEvent = new CoreSearchEvents();

// Event constants
export const searchInputEventInit: string = 'searchEvent:init';
export const searchInputEventUpdate: string = 'searchEvent:update';
export const searchFilterEventInit: string = 'searchFilterEvent:init';
export const searchFilterEventUpdate: string = 'searchFilterEvent:update';
export const searchFilterResetEvent: string = 'searchFilterEvent:reset';
export const searchCounterEventUpdate: string = 'searchCounterEvent:update';
export const searchFilterToggleEventUpdate: string = 'searchFilterToggleEvent:update';
export const searchTagEventUpdate: string = 'searchTagUpdateEvent:update';
export interface SearchInputEventData {
    searchInput: string;
}

export interface SearchFilterEventEventData {
    searchKey: string;
    searchValue: string;
}

export interface SearchCounterEventData {
    itemNumber: number;
}

export interface SearchFilterToggleEventData {
    isToggled: boolean;
}

export interface SearchTagEventData {
    tag: string;
}
